import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { CardElement, injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement, PostalCodeElement } from 'react-stripe-elements';

const createOptions = () => {
  return {
    style: {
      base: {
        color: '#676767',
        height: '24px',
        padding: '5px 10px',
        lineHeight: '24px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          fontFamily: "'Open Sans', sans-serif",
        },
      },
      invalid: {
        color: '#ff0000',
      },
    },
  };
};

class StripeCheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  async submit(ev) {
    // User clicked submit
    let { token } = await this.props.stripe.createToken({ name: "Name" });

    if (typeof this.props.onChange === "function") this.props.onChange(token);
    else if (typeof (this.props.onChange || {}).resolve === "function") this.props.onChange.resolve(token);
  }

  render() {
    return (
      <div>
        <div className='form__form-group'>
          <label className='form__form-group-label'>Card Number</label>
          {/* <CardElement /> */}
          <CardNumberElement
            placeholder=''
            {...createOptions()} />
        </div>
        <div className='form__form-group'>
          <Row className="row-75">
            <Col xs={6} className="col-75">
              <label className='form__form-group-label'>Expiry Date</label>
              <CardExpiryElement
                {...createOptions()} />
            </Col>
            <Col xs={6} className="col-75">
              <label className='form__form-group-label'>CVV</label>
              <CardCVCElement
                placeholder=''
                {...createOptions()} />
            </Col>
          </Row>
        </div>
        {/* <div className='form__form-group'>
          <label className='form__form-group-label'>Postal Code (ZIP)</label>
          <PostalCodeElement
            placeholder=''
            {...createOptions()} />
        </div> */}
        <p className="color-61">I agree to Rintagi terms of service.</p>
        <Row className="row-75 mt-20">
          <Col xs={6} className="col-75">
            <Button
              color="success"
              type='submit'
              className="btn btn-outline-success account__btn rounded"
              outline
              onClick={() => {this.props.history.goBack()}}>Back</Button>
          </Col>
          <Col xs={6} className="col-75">
            <Button
              color="success"
              type='submit'
              className="btn btn-success account__btn rounded"
              onClick={this.submit}>Place Order</Button>
          </Col>
        </Row>
        <p className="color-61"><i className="mdi mdi-lock payment-details-lock"></i> Your payment details are secured with SSL encryption</p>
      </div>
    );
  }
}

export default injectStripe(StripeCheckoutForm);


// WEBPACK FOOTER //
// ./src/components/custom/StripeCheckoutForm.js